import { useState, useCallback, useEffect } from "react";
import Header from "@/components/Header";
import BusinessHeroSection from "@/components/businesses/BusinessHeroSection";
import BusinessProblemCards from "@/components/businesses/BusinessProblemCards";
import BusinessDarkScrollSection from "@/components/businesses/BusinessDarkScrollSection";
import BusinessCTASection from "@/components/businesses/BusinessCTASection";
import Footer from "@/components/Footer";
import Preloader from "@/components/ui/layout-preloader";

const Businesses = () => {
  const [showPreloader, setShowPreloader] = useState(false);

  useEffect(() => {
    // Check if preloader has been shown before
    const hasSeenPreloader = localStorage.getItem('ayra-preloader-shown');
    if (!hasSeenPreloader) {
      setShowPreloader(true);
    }
  }, []);

  const handleComplete = useCallback(() => {
    setShowPreloader(false);
    // Mark preloader as shown in localStorage
    localStorage.setItem('ayra-preloader-shown', 'true');
  }, []);

  return (
    <>
      {showPreloader && <Preloader onComplete={handleComplete} />}
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <BusinessHeroSection />
          <BusinessProblemCards />
          <BusinessDarkScrollSection />
          <BusinessCTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Businesses;
